const videoInformation = [
  {
    title: 'Self-Regulation',
    password: 'Peekapak2020!',
    duration: '8:09 mins',
    description: () => (
      <>
        <p>
          This read aloud, created by award-winning social-emotional learning program, Peekapak, teaches young children
          the concept of Self-Regulation.
        </p>

        <p>
          Leo the Hedgehog feels nervous about his first day of school. Papa Hedgehog teaches Leo a poem about the value
          of sharing one&rsquo;s feelings with others. This poem helps Leo feel better. Throughout the day, Leo learns
          different strategies to help him manage his feelings. This book will help young children (pre-kindergarten /
          kindergarten) learn the importance of telling someone how they are feeling and discover new ways to manage
          their feelings.
        </p>

        <p>
          This story is fully illustrated, with emphasis placed on each character&rsquo;s emotion. Children will enjoy
          following along and naming the feelings shown vividly through each character&rsquo;s facial expression and
          body language.
        </p>

        <p>
          This story on Self-Regulation is the first book in our series. Our other stories feature our recurring
          colorful and diverse cast of characters teaching concepts like Respect, Gratitude, Kindness, Perseverance,
          Empathy, Teamwork, Honesty, Optimism and Courage
        </p>
      </>
    ),
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/SelfReg.png',
    videoUrl: 'https://vimeo.com/464340380',
    videoTitle: 'Self-Regulation',
    assetId: 'rcTU02oIGvBgc7FTW01ebD02ku00umnebbNsf5pFgaRGvhk',
  },
  {
    title: 'Respect',
    password: 'Peekapak2020!',
    duration: '7:57 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Respect.png',
    videoUrl: 'https://vimeo.com/464327250',
    videoTitle: 'Respect',
    assetId: 'jg2BP6wa902mpkKMJbbMkHUtYcZ02Ku015CsR2PQ6Ac102E',
    description: () => (
      <>
        <p>
          This read aloud, created by award-winning social-emotional learning program, Peekapak, teaches young children
          the concept of Respect.
        </p>
        <p>
          It&rsquo;s the Peekaville Elementary School Berryball Championship Game! Zoey learns that to be a good team
          leader, she must treat her teammates with kindness and respect.
        </p>
        <p>
          This story is fully illustrated, with emphasis placed on each character&rsquo;s emotion. Children will enjoy
          following the lesson and naming the feelings shown vividly through each character&rsquo;s facial expression
          and body language.
        </p>
        <p>
          This story on Respect is the second book in our series. Our other stories feature our recurring colorful and
          diverse cast of characters teaching concepts like Self-Regulation, Gratitude, Kindness, Perseverance, Empathy,
          Teamwork, Honesty, Optimism and Courage.
        </p>
      </>
    ),
  },
  {
    title: 'Gratitude',
    password: 'Peekapak2020!',
    duration: '8:00 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Gratitude.png',
    videoUrl: 'https://vimeo.com/464341089',
    videoTitle: 'Gratitude',
    assetId: '02v9SQ1kbeJxnoR2XqB3D2op1vqUVjiF5YrmoSkZbbog',
    description: () => (
      <>
        <p>
          This read aloud is created by award-winning social-emotional learning program, Peekapak. The story teaches
          young children about the concept of Gratitude.
        </p>

        <p>
          Cody is in a grumpy mood. It’s rainy and cold and nothing is going as planned. Later, he discovers a
          mysterious tree that reveals to him that there’s actually a lot for which to be thankful.
        </p>

        <p>
          This story is fully illustrated, with emphasis placed on each character&rsquo;s emotion. Children will enjoy
          following along and naming the feelings shown vividly through each character&rsquo;s facial expression and
          body language.
        </p>

        <p>
          This story on Gratitude is the third book in our series. Peekapak&rsquo;s stories feature our colorful and
          diverse cast of characters and teach concepts like Self-Regulation, Respect, Kindness, Perseverance, Empathy,
          Teamwork, Honesty, Optimism and Courage.
        </p>
      </>
    ),
  },
  {
    title: 'Perseverance',
    password: 'Peekapak2020!',
    duration: '8:34 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Perseverance.png',
    videoUrl: 'https://vimeo.com/461914381',
    videoTitle: 'Perseverance',
    assetId: 'q6xpPnVcDN9QlwIYWYqC65X008oE9ehIBIaHa01XMOEx4',
    description: () => (
      <>
        <p>
          This read aloud, created by award-winning social-emotional learning program, Peekapak, teaches young children
          the concept of Perseverance.
        </p>

        <p>
          Brady is holding auditions for his new band and Cody wants to try out. Even though it&rsquo;s not easy, he
          works hard to learn the drums in time for the big show.
        </p>

        <p>
          This story is fully illustrated, with emphasis placed on each character&rsquo;s emotion. Children will enjoy
          following the lesson and naming the feelings shown vividly through each character&rsquo;s facial expression
          and body language.
        </p>

        <p>
          This story on Perseverance is the 5th book in our series. Our other stories feature our recurring colorful and
          diverse cast of characters teaching concepts like Respect, Gratitude, Kindness, Empathy, Teamwork, Honesty,
          Optimism and Courage.
        </p>
      </>
    ),
  },
  {
    title: 'Empathy',
    password: 'Peekapak2020!',
    duration: '7:32 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Empathy.png',
    videoUrl: 'https://vimeo.com/461896716',
    videoTitle: 'Empathy',
    assetId: 'w02b8EpY3ayw01DZZmjsJWFGdvxgeint3Re01HM1OhAMyQ',
    description: () => (
      <>
        <p>
          This read aloud, created by award-winning social-emotional learning program, Peekapak, teaches young children
          the concept of Empathy.
        </p>

        <p>
          There’s a new student in peekaville and all the peekapals are abuzz with excitement. Despite their excitement
          the new student doesn’t want to hear about her new home so the pals need to learn to see things from her
          perspective.
        </p>
        <p>
          This story is fully illustrated, with emphasis placed on each character&rsquo;s emotion. Children will enjoy
          following along with the lesson, and naming the feelings shown vividly through each character&rsquo;s facial
          expression and body language.
        </p>
        <p>
          This story on Empathy is the 7th book in our series. Our other stories feature our recurring colorful and
          diverse cast of characters teaching concepts like Respect, Gratitude, Kindness, Perseverance, Teamwork,
          Honesty, Optimism and Courage.
        </p>
      </>
    ),
  },
  {
    title: 'Teamwork',
    password: 'Peekapak2020!',
    duration: '7:43 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Teamwork.png',
    videoUrl: 'https://vimeo.com/464333925',
    videoTitle: 'Teamwork',
    assetId: 's6AcHr007xaYbf01021cM9hKw1FpeljkFg4S1mUcAgeUgw',
    description: () => (
      <>
        <p>
          This read aloud created by award-winning social-emotional learning program, Peekapak, teaches young children
          the concept of Teamwork.
        </p>
        <p>The Peekapal’s go on an adventure to help Apollo and Sebastian perfect their newest invention.</p>
        <p>
          This story is fully illustrated, with emphasis placed on each character&rsquo;s emotion. Children will enjoy
          following along and naming the feelings shown vividly through each character&rsquo;s facial expression and
          body language.
        </p>
        <p>
          This story on Teamwork is the 6th book in our series. Our other stories feature our recurring colorful and
          diverse cast of characters teaching concepts like Respect, Gratitude, Kindness, Perseverance, Empathy,
          Honesty, Optimism and Courage.
        </p>
      </>
    ),
  },
  {
    title: 'Kindness',
    password: 'Peekapak2020!',
    duration: '8:18 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Kindness.png',
    videoUrl: 'https://vimeo.com/464333197',
    videoTitle: 'Kindness',
    assetId: '00ve9UOrgatBIGiUYtcpFwHu7YxJ7zcjc2IOn6RgzrSU',
    description: () => (
      <>
        <p>
          This read aloud, created by award-winning social-emotional learning program, Peekapak, teaches young children
          the concept of Kindness.
        </p>
        <p>
          All the Peekapals are preparing for the Winter Wonderlude celebration with their family and friends.
          Throughout the day Kenji helps everyone prepare and all the Peekapals help him prepare in return.
        </p>
        <p>
          This story is fully illustrated, with emphasis placed on each character&rsquo;s emotion. Children will enjoy
          following along and naming the feelings shown vividly through each character&rsquo;s facial expression and
          body language.
        </p>
        <p>
          This story on Kindness is the 4th book in our series. Our other stories feature our recurring colorful and
          diverse cast of characters teaching concepts like Respect, Gratitude, Perseverance, Empathy, Teamwork,
          Honesty, Optimism and Courage.
        </p>
      </>
    ),
  },
  {
    title: 'Honesty',
    password: 'Peekapak2020!',
    duration: '8:55 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Honesty.png',
    videoUrl: 'https://vimeo.com/464328454',
    videoTitle: 'Honesty',
    assetId: 'Y0200axr3QwrkRtVJVFxrRyS2iinzVIe1ke6QS2ZOXk3w',
    description: () => (
      <>
        <p>
          This read aloud, created by award-winning social-emotional learning program, Peekapak, teaches young children
          the concept of Honesty.
        </p>
        <p>
          There’s a big presentation coming up at peekaville elementary and everyone is getting ready. Unfortunately,
          Menka doesn’t have her presentation ready and she needs to decide if she will tell her teacher, and her
          friends, the truth.
        </p>
        <p>
          This story is fully illustrated, with emphasis placed on each character&rsquo;s emotion. Children will enjoy
          following along and naming the feelings shown vividly through each character&rsquo;s facial expression and
          body language.
        </p>
        <p>
          This story on Honesty is the 8th book in our series. Our other stories feature our recurring colorful and
          diverse cast of characters teaching concepts like Respect, Gratitude, Kindness, Perseverance, Empathy,
          Teamwork, Optimism and Courage.
        </p>
      </>
    ),
  },
  {
    title: 'Optimism',
    password: 'Peekapak2020!',
    duration: '10:33 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Optimism.png',
    videoUrl: 'https://vimeo.com/464306262',
    videoTitle: 'Optimism',
    assetId: 'azSt55ivtprEiV9QU3tzMb3YRXEy3aciNb02BbcfH5wE',
    description: () => (
      <>
        <p>
          This read aloud, created by award-winning social-emotional learning program, Peekapak, teaches young children
          the concept of Optimism.
        </p>
        <p>
          While gardening with her Dad, Lucia finds a secret box with hints leading to Reginald Peekapork’s lost
          treasure. Lucia spends the day tracking down the treasure despite a few bumps in the road.
        </p>
        <p>
          This story is fully illustrated, with emphasis placed on each character&rsquo;s emotion. Children will enjoy
          following the lesson and naming the feelings shown vividly through each character&rsquo;s facial expression
          and body language.
        </p>
        <p>
          This story on Optimism is the 9th book in our series. Our other stories feature our recurring colorful and
          diverse cast of characters teaching concepts like Respect, Gratitude, Kindness, Perseverance, Empathy,
          Teamwork, Honesty, and Courage.
        </p>
      </>
    ),
  },
  {
    title: 'Courage',
    password: 'Peekapak2020!',
    duration: '9:41 mins',
    graphicUrl: 'https://peekaplatform.s3.amazonaws.com/media30/images/thumbnails/videos/Courage.png',
    videoUrl: 'https://vimeo.com/461921059',
    videoTitle: 'Courage',
    assetId: '202ckUOZGc02yCC6P9XiTacUr9gCO9na8S1yep1vGWO2U',
    description: () => (
      <>
        <p>
          This read aloud, created by award-winning social-emotional learning program, Peekapak, teaches young children
          the concept of Courage.{' '}
        </p>
        <p>
          Sebastian the salamander is having a big pool party for all of his pals. Apollo can’t swim and doesn’t want to
          go to the party so he has to decide if he will brave the water to be with his friends.
        </p>
        <p>
          This story is fully illustrated, with emphasis placed on each character&rsquo;s emotion. Children will enjoy
          following the lesson and naming the feelings shown vividly through each character&rsquo;s facial expression
          and body language.
        </p>
        <p>
          This story on Courage is the 10th book in our series. Our other stories feature our recurring colorful and
          diverse cast of characters teaching concepts like Respect, Gratitude, Kindness, Perseverance, Empathy,
          Teamwork, Honesty, and Optimism.
        </p>
      </>
    ),
  },
];

export default videoInformation;
